import { InputLabel, Select } from '@mui/material'
import FormControl from '@mui/material/FormControl'
import { alpha } from '@mui/material/styles'
import React from 'react'
import { When } from 'react-if'

const getSelectStyles = (theme) => ({
  '&.MuiOutlinedInput-root': {
    ...theme.typography.body2,
  },
  '& .MuiSelect-select': {
    padding: theme.spacing(1, 2),
    color: theme.palette.text.secondary,
    backgroundColor: '#ffffff0d',
  },
  '& .MuiSelect-icon': {
    top: 'auto',
    color: theme.palette.text.secondary,
    width: theme.spacing(2),
    height: theme.spacing(2),
  },
})

const getMenuStyles = (theme) => ({
  '& .MuiList-root': {
    padding: '8px',
  },
  '& .MuiMenuItem-root': {
    ...theme.typography.body2,
    borderRadius: '4px',

    '&.Mui-selected': {
      background: alpha('#fff', 0.05),
    },
  },
})

const CustomMuiSelect = ({ children, sx = {}, isWithLabel = false, labelText, open, labelStyles, ...props }, ref) => (
  <FormControl
    style={{ height: '40px', minWidth: 'unset' }}
    variant="outlined"
  >
    <When condition={isWithLabel && !open && props.value === undefined}>
      <InputLabel
        sx={labelStyles}
        id={props.labelId}
      >
        {labelText}
      </InputLabel>
    </When>
    <Select
      sx={(theme) => ({ ...getSelectStyles(theme), ...(typeof sx === 'function' ? sx(theme) : sx) })}
      MenuProps={{
        sx: getMenuStyles,
      }}
      {...props}
      inputRef={ref}
    >
      {children}
    </Select>
  </FormControl>
)

export default React.forwardRef(CustomMuiSelect)
